import { BaseRequest } from './BaseRequest';

export class SearchMtlsCertificatesRequest extends BaseRequest {
    CertificateId: string
    OrganizationId: string
}
